import Icon from '@/components/base/Icon';
import {NotificationType} from '@/models/Notifications';

export default function NotificationIcon({type}: {type: NotificationType}) {
  switch (type) {
    case NotificationType.WARNING:
      return <Icon name="warning-outline" width={16} height={16} className="pt-0.5" />;
    case NotificationType.SUCCESS:
      return <Icon name="check-circle" width={16} height={16} viewBox="0 0 24 24" />;
    default: //error icon here
      return <Icon name="warning-outline" width={16} height={16} className="pt-0.5" />;
  }
}
